import Select, { components } from "react-select";
import "../../styles/react-select/_react-select.css";
import { IoIosArrowDown } from "react-icons/io";
import { IoCloseCircle } from "react-icons/io5";

export default function AutocompleteCustomA({
  options,
  value,
  onChange,
  onInputChange,
  disabled = false,
  placeholder = "",
  isClearable = false,
  height = "40px",
  isLoading = false,
}) {
  const DropdownIndicator = (props) => {
    const { menuIsOpen } = props.selectProps;

    return (
      <components.DropdownIndicator {...props}>
        <IoIosArrowDown
          className="my-auto"
          size={20}
          style={{
            color: "var(--color-on-base-content-high)",
            transition: "transform 0.2s ease",
            transform: menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </components.DropdownIndicator>
    );
  };

  const ClearIndicator = (props) => {
    return (
      <components.ClearIndicator {...props}>
        <IoCloseCircle
          size={16}
          style={{
            color: "var(--color-on-base-content-high)",
            opacity: 0.5,
            cursor: "pointer",
          }}
        />
      </components.ClearIndicator>
    );
  };

  return (
    <Select
      isLoading={isLoading}
      components={{
        DropdownIndicator,
        IndicatorSeparator: () => null,
        ClearIndicator,
      }}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: height,
          maxHeight: height,
          height,
          borderColor: state.isFocused
            ? "var(--color-primary, #3b82f6)"
            : "var(--color-on-base-border-default)",
          borderRadius: "8px",
          boxShadow: "none",
          "&:hover": {
            borderColor: "var(--color-on-base-border-default)",
          },
        }),
        placeholder: (provided) => ({
          ...provided,
          paddingBottom: "5px",
          color: "var(--color-on-base-content-low, #9ca3af)",
        }),
        input: (provided) => ({
          ...provided,
          paddingBottom: 0,
          margin: 0,
        }),
        valueContainer: (provided) => ({
          ...provided,
          minHeight: height,
          maxHeight: height,
          padding: "0px 0px 0px 10px",
          fontSize: 14,
        }),
        singleValue: (provided) => ({
          ...provided,
          paddingBottom: "2px",
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          height: height,
          alignItems: "center",
        }),
        clearIndicator: (provided) => ({
          ...provided,
          padding: "0 4px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          "&:hover": {
            opacity: 1,
          },
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: "0 8px 0 4px",
          display: "flex",
          alignItems: "center",
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
        menu: (provided) => ({
          ...provided,
          borderRadius: "8px",
          fontSize: 14,
          boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
        }),
        option: (provided, state) => ({
          ...provided,
          fontSize: 14,
          backgroundColor: state.isSelected
            ? "var(--color-primary, #3b82f6)"
            : state.isFocused
              ? "var(--color-primary-light, #eff6ff)"
              : "transparent",
        }),
      }}
      menuPlacement="auto"
      menuPosition="fixed"
      isClearable={isClearable}
      isDisabled={disabled}
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      className="basic-single"
      classNamePrefix="select"
    />
  );
}
